module.exports = __webpack_public_path__ + "static/media/logged-model.52a4e455.svg";